<template>
  <div class="calculator">
    <!-- <h3>{{user}}</h3> -->
    <!-- <div @click="ShareVk()">Поделиться</div> -->
    <div class="tabs">
      <div :class="activetab==1?'tabs__tab active':'tabs__tab'" @click="activetab=1">Смешарик</div>
      <div :class="activetab==2?'tabs__tab active':'tabs__tab'"  @click="activetab=2">Питомец</div>
    </div>
    <div class="smesh" v-if="activetab==1">
    <div class="app__screen">
      <div class="screen__error" v-if="result.error">{{result.error}}</div>
      <div class="screen__title">Твой уровень сейчас: </div>
      <div class="screen__input"><input v-model="ulvl" maxlength=3 placeholder="0" @keypress="onlyNumber" type="text"></div>
      <div class="screen__title">На какой уровень хочешь перейти?</div>
      <div class="screen__input"><input v-model="ulvlup" maxlength=3 :placeholder="+ulvl+1" type="text"></div>
      <!-- <div class="screen__btn" @click="calcLvl(ulvl, ulvlup)">Рассчитать</div> -->
    </div>
    <div class="result" v-if="result.exp">
      <div class="result__title">Чтобы перейти с {{ulvl?ulvl:1}} на {{ulvlup?ulvlup:+ulvl+1}} уровень, нужно: </div>
      <div class="result__icon result__exp">накопить {{this.result['exp']}} {{this.declOfNum(this.result['exp'],['звёздочка','звёздочки','звёздочек'])}}</div>
      <div class="result__title">А для этого ты можешь:</div>

      <div class="result__icon result__coins">потратить {{this.result['coins']}} {{this.declOfNum(this.result['coins'],['смешинка','смешинки','смешинок'])}}</div>
      <div class="result__icon result__rumb">потратить {{this.result['rumb']}} {{this.declOfNum(this.result['rumb'],['румбик','румбика','румбиков'])}}</div>
      <div class="result__icon result__game">победить в игре, где дают 15 смешинок, {{this.result['plays']}} раз</div>
      <div class="result__gift" v-if="this.info.gifts[ulvlup?ulvlup:+ulvl+1]">
        <div class="result__titler">На {{ulvlup?ulvlup:+ulvl+1}} уровне ты получишь:</div>
        <div class="result__item">
          <img class="result__img" :src="this.info.gifts[ulvlup?ulvlup:+ulvl+1].img" alt="">
          <div class="result__text">{{this.info.gifts[ulvlup?ulvlup:+ulvl+1].text}}</div>
          </div>
      </div>
    </div>
    </div>
    <div class="pet" v-if="activetab==2">
    <div class="app__screen">
      <div class="screen__error" v-if="resultp.error">{{resultp.error}}</div>
      <div class="screen__title">Уровень питомца сейчас: </div>
      <div class="screen__input"><input v-model="plvl" maxlength=3 placeholder="0" @keypress="onlyNumber" type="text"></div>
      <div class="screen__title">На какой уровень хочешь перейти?</div>
      <div class="screen__input"><input v-model="plvlup" maxlength=3 :placeholder="+plvl+1" type="text"></div>
      <!-- <div class="screen__btn" @click="calcLvl(ulvl, ulvlup)">Рассчитать</div> -->
    </div>
    <div class="resultp" v-if="resultp.exp">
      <div class="result__title">Чтобы питомцу перейти с {{plvl?plvl:1}} на {{plvlup?plvlup:+plvl+1}} уровень, нужно: </div>
      <div class="result__icon result__med">накопить {{this.resultp['exp']}} {{this.declOfNum(this.resultp['exp'],['медальку','медальки','медалек'])}}</div>

      <div class="result__title">А для этого ты можешь:</div>

      <div class="result__icon result__win">победить {{Math.ceil(this.resultp['max']/2)}} {{this.declOfNum(Math.ceil(this.resultp['max']/2),['раз','раза','раз'])}} с картой или {{this.resultp['max']}} {{this.declOfNum(this.resultp['max'],['раз','раза','раз'])}} без карты питомца уровнем выше</div>
      <div class="result__icon result__win">победить {{Math.ceil(this.resultp['s']/2)}} {{this.declOfNum(Math.ceil(this.resultp['s']/2),['раз','раза','раз'])}} с картой или {{this.resultp['s']}} {{this.declOfNum(this.resultp['s'],['раз','раза','раз'])}} без карты питомца того же уровня</div>
      <div class="result__icon result__win">победить {{Math.ceil(this.resultp['min']/2)}} {{this.declOfNum(Math.ceil(this.resultp['min']/2),['раз','раза','раз'])}} с картой или {{this.resultp['min']}} {{this.declOfNum(this.resultp['min'],['раз','раза','раз'])}} без карты питомца уровнем ниже</div>
    </div>
    </div>
    <!-- <div class="channels__item" v-for="item in channels" v-if="ulvl>0">
      <img class="channel__avatar" :src="item.avatar"/>
      <div class="channel__info">
        <div class="channel__title">{{item.title}}</div>
        <div class="channel__descr">{{item.descr}}</div>
        <div class="channel__view">{{item.view}} зрителя</div>
      </div>
    </div> -->
  </div>
</template>

<script>
import connect from '@vkontakte/vkui-connect'
import axios from 'axios'
// import lvls from '../assets/lvl.json';
export default {
  name: 'LvlApp',
  data () {
    return {
      info: [],
      ulvl: null,
      ulvlup: null,
      plvl: null,
      plvlup: null,
      result: {},
      resultp: {},
      activetab: 1
    }
  },
    watch: {
    ulvl: function () {
     if (this.ulvl>199) {
     this.ulvl = 199;
   }
     if (this.ulvl<0) {
     this.ulvl = null;
   }
      this.calcLvl(this.ulvl, this.ulvlup)
    },
       ulvlup: function () {
       if (this.ulvlup>200) {
     this.ulvlup = 200;
   }
     if (this.ulvlup<0) {
     this.ulvlup = null;
   }
      this.calcLvl(this.ulvl, this.ulvlup)
    },
    plvl: function () {
     if (this.plvl>49) {
     this.plvl = 49;
   }
     if (this.plvl<0) {
     this.plvl = null;
   }
      this.calcpLvl(this.plvl, this.plvlup)
    },
       plvlup: function () {
       if (this.plvlup>50) {
     this.plvlup = 50;
   }
     if (this.plvlup<0) {
     this.plvlup = null;
   }
      this.calcpLvl(this.plvl, this.plvlup)
    },
    },

  mounted() {
      axios
      .get('./lvls.json')
      .then(response => (this.info = response.data));
    if (localStorage.user) {
      this.user = JSON.parse(localStorage.user);
    }

  },
  methods: {
    ShareVk() {
    // connect.send("VKWebAppShowWallPostBox", {"message": "Hello!"});
connect.send("VKWebAppJoinGroup", {"group_id": 106849164});

    },
   declOfNum(number, titles)   {
    let cases = [2, 0, 1, 1, 1, 2];
    return titles[ (number%100>4 && number%100<20)? 2 : cases[(number%10<5)?number%10:5] ];
},
    calcLvl(lvl,lvlup) {
      if (lvl==null) lvl =1
      lvlup = lvlup!=null?+lvlup:+lvl+1;
      lvl = +lvl;
      let result = {};
      if ((lvl<lvlup) && (lvl<200) && (lvlup<=200) && (lvl>0) && (lvlup>1)) {
      result['exp'] = this.info.le[lvlup]-this.info.le[lvl];
      result['coins'] = Math.ceil(result['exp']*2);
      result['plays'] = Math.ceil(result['exp']/15);
      result['rumb'] = Math.ceil(result['exp']/25);
      } else {
        result['error'] = "Поля заполнены некорректно";
      }
      this.result = result;
    },
    calcpLvl(lvl,lvlup) {
      if (lvl==null) lvl =1
      lvlup = lvlup!=null?+lvlup:+lvl+1;
      lvl = +lvl;
      let result = {};
      if ((lvl<lvlup) && (lvl<50) && (lvlup<=50) && (lvl>0) && (lvlup>1)) {
      result['exp'] = this.info.pl[lvlup]-this.info.pl[lvl];
      result['max'] = Math.ceil(result['exp']/20);
      result['s'] = Math.ceil(result['exp']/15);
      result['min'] = Math.ceil(result['exp']/10);

      } else {
        result['error'] = "Поля заполнены некорректно";
      }
      this.resultp = result;
    },
onlyNumber ($event) {
   //console.log($event.keyCode); //keyCodes value
   let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
   if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
      $event.preventDefault();
   }
}
 }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
